import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import { wrapRouterMethod } from "./safeNavigation";
import { reloadOnceOnJsChunkError } from "./reloadOnceOnJsChunkError";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes,
});

// Falhas esperadas do vue-router (duplicated/cancelled/aborted/redirected)
// são engolidas no wrapper; erros reais (ex.: TypeError) continuam rejeitando.
// 2a camada: o ignoreErrors do Sentry (main.js) cobre NavigationFailure que
// NÃO passa por push/replace (ex.: redirect interno disparado em navigation guard).
// Manter as duas camadas — remover uma reintroduz o ruído por outro caminho.
const originalPush = router.push.bind(router);
const originalReplace = router.replace.bind(router);

router.push = wrapRouterMethod(originalPush, "push");
router.replace = wrapRouterMethod(originalReplace, "replace");

router.onError((err) => {
  reloadOnceOnJsChunkError(err);
});

export default router;
